var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 33,
    viewBox: "0 0 150 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0605469 11.6467L11.5789 5.7514L23.0973 3.64594L34.6157 1.11938L46.1341 9.54123L57.6524 5.33031L69.1708 13.7522L80.6892 14.5943L92.2076 10.8045L103.726 7.43577L115.244 4.48812L126.763 12.4889L138.281 16.6998L149.799 3.22485",
    stroke: "url(#paint0_linear_1506_12711)",
    strokeWidth: 1.29837
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_12711",
    x1: 74.93,
    y1: 16.6998,
    x2: 74.93,
    y2: 1.11938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C84CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F1A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScChartLine);
export default __webpack_public_path__ + "static/media/sc-chart-line.90e0cef6cdc529af60a5b4bb939a6809.svg";
export { ForwardRef as ReactComponent };